
/*
 *  WOL - add to modal links:
 *   data-bs-target="#page-modal-wol"
 *   data-bs-toggle ="modal"
 *   data-link="https://www.example.com"
 */

(function () {
  document.addEventListener('DOMContentLoaded', function () {

    function getCookie(name) {
      const cookieName = name + '=';
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
          return cookie.substring(cookieName.length);
        }
      }

      return null;
    }

    function setCookie(name, value, days) {
      let expires = '';

      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }

      document.cookie = name + '=' + value + expires + '; path=/';
    }

    getModalBtnWrapLinks = (function () {
        const modalButtonLinks = document.querySelectorAll('.modal-btn-prevent-default a');
        modalButtonLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
          });
        });
    })();

    // Warn on leave: customize BS modal
    warnOnLeave = function () {

      if (!document.getElementById('page-modal-wol') ) {
        return;
      }

      var pageModalWol = new bootstrap.Modal(document.getElementById('page-modal-wol'), {
        keyboard: false,     // Prevents close on Escape key press
        backdrop: 'modal',   // Close on outside click
      });

      let popupsLinks = document.querySelectorAll('[data-bs-target="#page-modal-wol"]');
      let closeBtn = document.querySelectorAll('.btn-modal-close-wol');
      let externalLink = document.getElementById('externalLink');

      popupsLinks.forEach(function (popupLink) {
          popupLink.addEventListener('click', function (e) {
              e.preventDefault();
              externalLink.querySelector('a').setAttribute('href', this.getAttribute('data-link'));
              pageModalWol.show();
          });
      });

      externalLink.addEventListener('click', function (e) {
        pageModalWol.hide();
      });


      closeBtn.forEach(function (popupLink) {
          popupLink.addEventListener('click', function (e) {
              e.preventDefault();
              pageModalWol.hide();
          });
      });

    }();

    // Warn on entry: customize BS modal
    warnOnEntry = function () {

      if (!document.getElementById('page-modal-woe') ) {
        return;
      }

      var pageModalWoe = new bootstrap.Modal(document.getElementById('page-modal-woe'), {
          backdrop: 'static', // Prevents close on outside click
          keyboard: false     // Prevents close on Escape key press
      });

      if (!getCookie('modalWoeShown')) {
        let closeBtn = document.querySelectorAll('.btn-modal-close-woe');

        pageModalWoe.show();

        closeBtn.forEach(function (popupLink) {
          popupLink.addEventListener('click', function (e) {
              e.preventDefault();
              pageModalWoe.hide();

              setCookie('modalWoeShown', 'true', 365);
          });
        });
      } else {
          console.log("Returning visitor - not firing modal");
      }

    }();

  });
})();